import { Observable } from "rxjs";
import { TransportadoraAPI } from '@/api/transportadora.api';

const api = new TransportadoraAPI();

const consultaTransportadoraRegularizada = (body: any): Observable<any> => {
  return api.consultaTransportadoraRegularizada(body);
};


export default {
  consultaTransportadoraRegularizada
};



